import { useQuery } from "@tanstack/react-query";
import { sdk } from "@/config/medusa";
import { handleErrorToast } from "@/utils/helpers";
import { useUser } from "@/context/user";
import storage from "@/utils/storage";
import { Brand } from "@/types/brand";

const useQueryBrands = () => {
  const isAuthenticated = useUser((state) => state.isAuthenticated);
  const vid = storage.getItem("vid");

  const getBrands = async () => {
    try {
      const data = await sdk.client.fetch<Brand[]>(
        `/vendor/${vid}/brands`
      );
      return data;
    } catch (e) {
      handleErrorToast(e);
    }
  };

  const query = useQuery({
    queryKey: ["brands", vid],
    queryFn: getBrands,
    enabled: isAuthenticated,
  });

  return {
    ...query,
    isFetching: query.isFetching,
  };
};

export default useQueryBrands;
